import styled, { keyframes } from "styled-components";

const slideIn = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`

const slideOut = keyframes`
  from {
    transform: translateY(0%);
  }
  to {
    transform: translateY(100%);
  }
`

const backgroundIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const backgroundOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`

const Wrapper = styled.div<{
  $isOpen           : boolean,
  $hiddenAfterClose : boolean
}>`

  position            : fixed;
  left                : 0;
  bottom              : 0;
  overflow-x          : hidden;
  overflow-y          : hidden;
  z-index             : 4;

  visibility          : ${(props) => (props.$hiddenAfterClose ? "hidden" : "visible")};
  
  width               : 100%;
  height              : 100%;

  &::before {
    position          : fixed;
    content           : "";
    top               : 0px;
    left              : 0px;
    width             : 100dvw;
    height            : 100dvh;
    background-color  : ${props => props.$isOpen ? 'rgb(16 18 18 / 0.8)' : 'rgb(16 18 18 / 0)'};
    animation         : ${props => props.$isOpen ? backgroundIn : backgroundOut} 0.25s ${props => props.$isOpen ? "cubic-bezier(0, 0.97, 0.1, 1)" : "cubic-bezier(1, 0, 0, 1)"} forwards;
  }

`;

const Content = styled.div<{
  $isOpen: boolean
}>` 

  animation               : ${props => props.$isOpen ? slideIn : slideOut} 0.25s ${props => props.$isOpen ? "cubic-bezier(0, 0.97, 0.1, 1)" : "cubic-bezier(1, 0, 0, 1)"} forwards;
  
  background              : #152239;
  bottom                  : 0;
  left                    : 0;
  right                   : 0;
  width                   : 100% !important;
  border-top-left-radius  : .75rem;
  border-top-right-radius : .75rem;

  color                   : #cccccc;

  /* POP CENTER */
  position                : absolute;
  opacity                 : 1;
  display                 : flex;
  flex-direction          : column;
  max-height              : 90%;
  padding-top             : 3.5rem;

`;

const PopTitle = styled.div`

  position                : absolute;
  top                     : 0;
  width                   : 100%;
  justify-content         : center;
  align-items             : center;
  font-weight             : 800;
  height                  : 3.5rem;
  font-size               : 1rem;
  display                 : flex;
  flex                    : none;
  color                   : #cccccc;

`;

const PopContent = styled.div`

  overflow-y              : auto;
  overflow-x              : hidden;
  overscroll-behavior     : contain;

`;

const CloseButton = styled.div`

  position                : absolute;
  right                   : .5rem;
  top                     : .5rem;
  background              : #1d2c45;
  border-radius           : .5rem;
  padding                 : .1rem;

  .itd-button.itd-button-ghost:hover {
    background            : #1d2c45;
  }

  .itd-button-xs .icon svg {
    width                 : 1.25rem;
    height                : 1.25rem;
  }

`

export { Wrapper, Content, PopTitle, PopContent, CloseButton };